export interface IPage<T> {
  data: T
  total: number
  totalPage: number
  currentPage: number
}

export enum IStatusData {
  PENDING = 1,
  APPROVED = 2,
  DISAPPROVED = 3,
}

export interface IWhitelist {
  action: any | undefined
  buyingAmount: string | undefined
  network: string | undefined
  networkId: number | undefined
  twitter: string | undefined
  email: string | undefined
  status: IStatusData
  userId: number
  userName: string
  walletAddress: string
  isUpdate: number
  createdAt: string
  updatedAt: string
}

export interface IArtist {
  status: IStatusData
  userId: number
  userName: string
  email: string
  twitter: string
  picture: string
  firstAnswer: any
  secondAnswer: any
  address: string
  instagramSite: string
  createdAt: string
  updatedAt: string
}

export interface IUserInformation {
  id: number
  userName: string
  password: undefined | string
  email: undefined | string
  role: number
  emailVerificationToken: undefined | string
  emailVerified: boolean
  avatar: undefined | string
  firstName: undefined | string
  lastName: undefined | string
  name: undefined | string
  phone: undefined | string
  about: undefined | string
  website: undefined | string
  facebookSite: undefined | string
  instagramSite: undefined | string
  twitterSite: undefined | string
  youtubeSite: undefined | string
  inviteCode: string
  following: number
  followers: number
  userNftRole: number
  status: number
  createdAt: Date
  updatedAt: Date
  forgotPassword: undefined | string
  lastLogin: undefined | Date
  userWallet: {
    id: number
    address: string
    type: number
    nonce: number
  }
}

export interface ILoginExternalWallet {
  access_token: string
  user: IUserInformation
}

export interface IErrorMessage {
  messageCode: string
  description: string
}

export interface INetwork {
  id: number
  name: string
  chainId: number
  marketContract: string
  xanalia1155GeneralContract: string
  xanalia721GeneralContract: string
  xanaliaDexContract: string
  offerDexContract: string
  xanaliaURIContract: string
  xanaliaTreasury: string
  auctionContract: string
  rpc: string
  image: string
  gasLimit: number
  gasLimitCollection: number
  gasPrice: string
  status: number
  createdAt: string
  networkTokens: Array<INetWorkTokens>
}
export interface INetWorkTokens {
  id: number
  tokenName: string
  decimal: number
  networkId: number
  contractAddress: string
  status: number
  isNativeToken: number
  currency: string
  icon: string
  createdAt: string
}
